import React from "react";
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from './RenderIf'

const Trajectory = ({
  low = "",
  high = "",
  units = "",
  just = "",
  handleChange = function () {
    console.log("no function defined");
  },
}) => {
  return (
    <General.BlockContainer>
      <General.Block>
        <FloatCard width="300px">
          <General.InputCont>
            <p>
              A trajectory represents the best scientific evidence of a rate of
              change regarding a metric.
            </p>
          </General.InputCont>
          <General.InputCont>
            <General.Input
            className="input"
              type="number"
              name="trajectLow"
              value={low}
              onChange={handleChange}
              placeholder="  "
              required
            />
            <General.Label className="placeholder" >Low</General.Label>
          </General.InputCont>
          <General.InputCont>
            <General.Input
            className="input"
              type="number"
              name="trajectHigh"
              value={high}
              onChange={handleChange}
              placeholder=" "
              required
            />
            <General.Label className="placeholder" >High</General.Label>
          </General.InputCont>
          <RenderIf isTrue={units.length > 0}>
          <General.InputCont>
            <span>Units per Year: {units}</span>
          </General.InputCont>
          </RenderIf>
          <RenderIf isTrue={units.length === 0}
        >
          <General.InputCont>
          <p>Units will carry down from the current or most recent measurement.  Please fill that section out first.</p>
          </General.InputCont>
        </RenderIf>
        <General.InputCont margin='0 1rem'>
          <span >
            Justification
          </span>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
            <General.Text
            className="input"
              name="trajectJust"
              value={just}
              onChange={handleChange}
              placeholder=' '
              required
            ></General.Text>
            <General.Label className="placeholder" >Trajectory source?</General.Label>
          </General.InputCont>
          <General.InputCont>
            <p>You can drag the lower right corner to make more room.</p>
          </General.InputCont>
        </FloatCard>
      </General.Block>
      <General.Block color={theme.colors.grey4}>
        <div>
          <h2>Trajectory</h2>
         
            <General.LimitText width="250px">Future metric values of a location based on current or
     historical trends.</General.LimitText>
          
        </div>
      </General.Block>
    </General.BlockContainer>
  );
};

export default Trajectory;
